export default __webpack_public_path__ + "static/media/SJA1390.34I-42034_-25252_0.e87a2815.jpg";